const countries=[
{code:'AF',name:'Afganistán',dialcode:'93'},
{code:'AL',name:'Albania',dialcode:'355'},
{code:'DE',name:'Alemania',dialcode:'49'},
{code:'AD',name:'Andorra',dialcode:'376'},
{code:'AO',name:'Angola',dialcode:'244'},
{code:'AI',name:'Anguila',dialcode:'1264'},
{code:'AQ',name:'Antártida',dialcode:'672'},
{code:'SA',name:'ArabiaSaudita',dialcode:'966'},
{code:'DZ',name:'Argelia',dialcode:'213'},
{code:'AR',name:'Argentina',dialcode:'54'},
{code:'AM',name:'Armenia',dialcode:'374'},
{code:'AW',name:'Aruba',dialcode:'297'},
{code:'AU',name:'Australia',dialcode:'61'},
{code:'AT',name:'Austria',dialcode:'43'},
{code:'AZ',name:'Azerbaiyán',dialcode:'994'},
{code:'BS',name:'Bahamas',dialcode:'*'},
{code:'BH',name:'Bahréin',dialcode:'973'},
{code:'BD',name:'Bangladesh',dialcode:'880'},
{code:'BB',name:'Barbados',dialcode:'*'},
{code:'BE',name:'Bélgica',dialcode:'32'},
{code:'BZ',name:'Belice',dialcode:'501'},
{code:'BJ',name:'Benín',dialcode:'229'},
{code:'BM',name:'Bermudas',dialcode:'*'},
{code:'BY',name:'Bielorrusia',dialcode:'375'},
{code:'MM',name:'Birmania(Myanmar)',dialcode:'95'},
{code:'BO',name:'Bolivia',dialcode:'591'},
{code:'BA',name:'Bosnia-Herzegovina',dialcode:'387'},
{code:'BW',name:'Botsuana',dialcode:'267'},
{code:'BR',name:'Brasil',dialcode:'55'},
{code:'BN',name:'Brunéi',dialcode:'673'},
{code:'BG',name:'Bulgaria',dialcode:'359'},
{code:'BF',name:'BurkinaFaso',dialcode:'226'},
{code:'BI',name:'Burundi',dialcode:'257'},
{code:'BT',name:'Bután',dialcode:'975'},
{code:'CV',name:'CaboVerde',dialcode:'238'},
{code:'KH',name:'Camboya',dialcode:'855'},
{code:'CM',name:'Camerún',dialcode:'237'},
{code:'CA',name:'Canadá',dialcode:'*'},
{code:'CL',name:'Chile',dialcode:'56'},
{code:'CN',name:'China',dialcode:'86'},
{code:'CY',name:'Chipre',dialcode:'357'},
{code:'CO',name:'Colombia',dialcode:'57'},
{code:'KM',name:'Comoras',dialcode:'269'},
{code:'KP',name:'CoreadelNorte',dialcode:'850'},
{code:'KR',name:'CoreadelSur',dialcode:'82'},
{code:'CI',name:'CostadeMarfil',dialcode:'225'},
{code:'CR',name:'CostaRica',dialcode:'506'},
{code:'HR',name:'Croacia',dialcode:'385'},
{code:'CU',name:'Cuba',dialcode:'53'},
{code:'CW',name:'Curazao',dialcode:'599'},
{code:'DK',name:'Dinamarca',dialcode:'45'},
{code:'DJ',name:'Djibuti',dialcode:'253'},
{code:'DM',name:'Dominica',dialcode:'*'},
{code:'EC',name:'Ecuador',dialcode:'593'},
{code:'EG',name:'Egipto',dialcode:'20'},
{code:'EH',name:'ElSáharaEspañol',dialcode:'*'},
{code:'SV',name:'ElSalvador',dialcode:'503'},
{code:'VA',name:'ElVaticano',dialcode:'*'},
{code:'AE',name:'EmiratosÁrabesUnidos',dialcode:'971'},
{code:'ER',name:'Eritrea',dialcode:'291'},
{code:'SK',name:'Eslovaquia',dialcode:'421'},
{code:'SI',name:'Eslovenia',dialcode:'386'},
{code:'ES',name:'España',dialcode:'34'},
{code:'US',name:'EstadosUnidos',dialcode:'1'},
{code:'EE',name:'Estonia',dialcode:'372'},
{code:'ET',name:'Etiopía',dialcode:'251'},
{code:'PH',name:'Filipinas',dialcode:'63'},
{code:'FI',name:'Finlandia',dialcode:'358'},
{code:'FJ',name:'Fiyi',dialcode:'679'},
{code:'FR',name:'Francia',dialcode:'33'},
{code:'GA',name:'Gabón',dialcode:'241'},
{code:'GM',name:'Gambia',dialcode:'220'},
{code:'GE',name:'Georgia',dialcode:'995'},
{code:'GH',name:'Ghana',dialcode:'233'},
{code:'GI',name:'Gibraltar',dialcode:'350'},
{code:'GR',name:'Grecia',dialcode:'30'},
{code:'GL',name:'Groenlandia',dialcode:'299'},
{code:'GP',name:'Guadalupe',dialcode:'590'},
{code:'GU',name:'Guam',dialcode:'1671'},
{code:'GT',name:'Guatemala',dialcode:'502'},
{code:'GN',name:'Guinea',dialcode:'224'},
{code:'GQ',name:'GuineaEcuatorial',dialcode:'240'},
{code:'GW',name:'Guinea-Bissáu',dialcode:'245'},
{code:'GY',name:'Guyana',dialcode:'592'},
{code:'HT',name:'Haití',dialcode:'509'},
{code:'NL',name:'Holanda',dialcode:'31'},
{code:'HN',name:'Honduras',dialcode:'504'},
{code:'HK',name:'HongKong',dialcode:'852'},
{code:'HU',name:'Hungría',dialcode:'36'},
{code:'IN',name:'India',dialcode:'91'},
{code:'ID',name:'Indonesia',dialcode:'62'},
{code:'IQ',name:'Irak',dialcode:'964'},
{code:'IR',name:'Irán',dialcode:'98'},
{code:'IE',name:'Irlanda',dialcode:'353'},
{code:'IM',name:'IsladeMan',dialcode:'*'},
{code:'NF',name:'IslaNorfolk',dialcode:'*'},
{code:'IS',name:'Islandia',dialcode:'354'},
{code:'KY',name:'IslasCaimán',dialcode:'1-345'},
{code:'CK',name:'IslasCook',dialcode:'682'},
{code:'FO',name:'IslasFeroe',dialcode:'298'},
{code:'FK',name:'IslasMalvinas',dialcode:'500'},
{code:'MP',name:'IslasMarianasdelNorte',dialcode:'1670'},
{code:'MH',name:'IslasMarshall',dialcode:'692'},
{code:'PN',name:'IslasPitcairn',dialcode:'870'},
{code:'SB',name:'IslasSalomón',dialcode:'677'},
{code:'VG',name:'IslasVírgenesBritánicas',dialcode:'1284'},
{code:'IL',name:'Israel',dialcode:'972'},
{code:'IT',name:'Italia',dialcode:'39'},
{code:'JM',name:'Jamaica',dialcode:'*'},
{code:'JP',name:'Japón',dialcode:'81'},
{code:'JO',name:'Jordania',dialcode:'962'},
{code:'KZ',name:'Kazajistán',dialcode:'*'},
{code:'KE',name:'Kenia',dialcode:'254'},
{code:'KG',name:'Kirgizistán',dialcode:'996'},
{code:'KI',name:'Kiribati',dialcode:'686'},
{code:'XK',name:'Kosovo',dialcode:'*'},
{code:'KW',name:'Kuwait',dialcode:'965'},
{code:'LA',name:'Laos',dialcode:'856'},
{code:'LS',name:'Lesoto',dialcode:'266'},
{code:'LV',name:'Letonia',dialcode:'371'},
{code:'LB',name:'Líbano',dialcode:'961'},
{code:'LR',name:'Liberia',dialcode:'231'},
{code:'LY',name:'Libia',dialcode:'218'},
{code:'LI',name:'Liechtenstein',dialcode:'423'},
{code:'LT',name:'Lituania',dialcode:'370'},
{code:'LU',name:'Luxemburgo',dialcode:'352'},
{code:'MO',name:'Macao',dialcode:'853'},
{code:'MK',name:'Macedonia',dialcode:'389'},
{code:'MG',name:'Madagascar',dialcode:'261'},
{code:'MY',name:'Malasia',dialcode:'60'},
{code:'MW',name:'Malaui',dialcode:'265'},
{code:'MV',name:'Maldivas',dialcode:'960'},
{code:'ML',name:'Mali',dialcode:'223'},
{code:'MT',name:'Malta',dialcode:'356'},
{code:'MA',name:'Marruecos',dialcode:'212'},
{code:'MU',name:'Mauricio',dialcode:'230'},
{code:'MR',name:'Mauritania',dialcode:'222'},
{code:'MX',name:'México',dialcode:'52'},
{code:'FM',name:'Micronesia',dialcode:'691'},
{code:'MD',name:'Moldavia',dialcode:'373'},
{code:'MC',name:'Mónaco',dialcode:'377'},
{code:'MN',name:'Mongolia',dialcode:'976'},
{code:'ME',name:'Montenegro',dialcode:'382'},
{code:'MS',name:'Montserrat',dialcode:'1664'},
{code:'MZ',name:'Mozambique',dialcode:'258'},
{code:'NA',name:'Namibia',dialcode:'264'},
{code:'NR',name:'Nauru',dialcode:'674'},
{code:'NP',name:'Nepal',dialcode:'977'},
{code:'NI',name:'Nicaragua',dialcode:'505'},
{code:'NE',name:'Níger',dialcode:'227'},
{code:'NG',name:'Nigeria',dialcode:'234'},
{code:'NU',name:'Niue',dialcode:'683'},
{code:'NO',name:'Noruega',dialcode:'47'},
{code:'NC',name:'NuevaCaledonia',dialcode:'687'},
{code:'NZ',name:'NuevaZelanda',dialcode:'64'},
{code:'OM',name:'Omán',dialcode:'968'},
{code:'PK',name:'Pakistán',dialcode:'92'},
{code:'PW',name:'Palau',dialcode:'680'},
{code:'PA',name:'Panamá',dialcode:'507'},
{code:'PG',name:'PapúaNuevaGuinea',dialcode:'675'},
{code:'PY',name:'Paraguay',dialcode:'595'},
{code:'PE',name:'Perú',dialcode:'51'},
{code:'PF',name:'PolinesiaFrancesa',dialcode:'689'},
{code:'PL',name:'Polonia',dialcode:'48'},
{code:'PT',name:'Portugal',dialcode:'351'},
{code:'PR',name:'PuertoRico',dialcode:'*'},
{code:'QA',name:'Qatar',dialcode:'974'},
{code:'GB',name:'ReinoUnido',dialcode:'44'},
{code:'CF',name:'RepúblicaCentroafricana',dialcode:'236'},
{code:'CZ',name:'RepúblicaCheca',dialcode:'420'},
{code:'SS',name:'RepúblicadeSudándelSur',dialcode:'211'},
{code:'CG',name:'RepúblicadelCongo',dialcode:'242'},
{code:'CD',name:'RepúblicaDemocráticadelCongo',dialcode:'243'},
{code:'DO',name:'RepúblicaDominicana',dialcode:'*'},
{code:'RE',name:'Reunión',dialcode:'262'},
{code:'RW',name:'Ruanda',dialcode:'250'},
{code:'RO',name:'Rumanía',dialcode:'40'},
{code:'RU',name:'Rusia',dialcode:'7'},
{code:'WS',name:'Samoa',dialcode:'685'},
{code:'AS',name:'SamoaAmericana',dialcode:'1684'},
{code:'BL',name:'SanBartolomé',dialcode:'*'},
{code:'KN',name:'SanCristóbalyNevis',dialcode:'*'},
{code:'SM',name:'SanMarino',dialcode:'378'},
{code:'MF',name:'SanMartín',dialcode:'1599'},
{code:'PM',name:'SanPedroyMiquelón',dialcode:'508'},
{code:'VC',name:'SanVicenteylasGranadinas',dialcode:'*'},
{code:'SH',name:'SantaElena',dialcode:'290'},
{code:'LC',name:'SantaLucía',dialcode:'*'},
{code:'ST',name:'SantoToméyPríncipe',dialcode:'239'},
{code:'SN',name:'Senegal',dialcode:'221'},
{code:'RS',name:'Serbia',dialcode:'381'},
{code:'SC',name:'Seychelles',dialcode:'248'},
{code:'SL',name:'SierraLeona',dialcode:'232'},
{code:'SG',name:'Singapur',dialcode:'65'},
{code:'SY',name:'Siria',dialcode:'963'},
{code:'SO',name:'Somalia',dialcode:'252'},
{code:'LK',name:'SriLanka',dialcode:'94'},
{code:'ZA',name:'Sudáfrica',dialcode:'27'},
{code:'SD',name:'Sudán',dialcode:'249'},
{code:'SE',name:'Suecia',dialcode:'46'},
{code:'CH',name:'Suiza',dialcode:'41'},
{code:'SR',name:'Surinam',dialcode:'597'},
{code:'SZ',name:'Swazilandia',dialcode:'268'},
{code:'TH',name:'Tailandia',dialcode:'66'},
{code:'TW',name:'Taiwán',dialcode:'886'},
{code:'TZ',name:'Tanzania',dialcode:'255'},
{code:'TJ',name:'Tayikistán',dialcode:'992'},
{code:'TL',name:'TimorOriental',dialcode:'670'},
{code:'TG',name:'Togo',dialcode:'228'},
{code:'TK',name:'Tokelau',dialcode:'690'},
{code:'TT',name:'TrinidadyTobago',dialcode:'*'},
{code:'TN',name:'Túnez',dialcode:'216'},
{code:'TM',name:'Turkmenistán',dialcode:'993'},
{code:'TR',name:'Turquía',dialcode:'90'},
{code:'TV',name:'Tuvalu',dialcode:'688'},
{code:'UA',name:'Ucrania',dialcode:'380'},
{code:'UG',name:'Uganda',dialcode:'256'},
{code:'UY',name:'Uruguay',dialcode:'598'},
{code:'UZ',name:'Uzbekistán',dialcode:'998'},
{code:'VU',name:'Vanuatu',dialcode:'678'},
{code:'VE',name:'Venezuela',dialcode:'58'},
{code:'VN',name:'Vietnam',dialcode:'84'},
{code:'YE',name:'Yemen',dialcode:'967'},
{code:'ZM',name:'Zambia',dialcode:'260'},
{code:'ZW',name:'Zimbabue',dialcode:'263'}
]
export default countries;